import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useMe } from '@/hooks/use-me';

// Gate de rol para las rutas admin-only (Administración, Auditoría — MVP
// §5.0 / B.1 punto 4). RequireAuth ya garantizó que hay sesión antes de
// llegar acá; esto es la segunda capa — evita que un viewer/gestor entre a
// mano por URL. El ítem de nav ya se oculta para no-admins (nav-items.ts +
// sidebar.tsx), esto cubre la navegación directa.
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { data: user } = useMe();
  if (user?.rol !== 'admin') return <Navigate to="/" replace />;
  return <>{children}</>;
}
